import React, { useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { LeaveTransaction } from "../types/LeaveTransaction";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { fetchLeaveRequests } from "../redux/actions/leaveRequestAction";
import { AppDispatch } from "../redux/store";
import "../styles/EmployeeList.css";
import { Edit, Trash } from "lucide-react";
import { LocalFormatDate } from "../config/functions";

interface Props {
  list: LeaveTransaction[];
  onEdit: (item: LeaveTransaction) => void;
  onDelete: (id: number) => void;
}
const LeaveTransactionList: React.FC<Props> = ({ list, onEdit, onDelete }) => {
  const leaveRequests = useSelector((state: StoreState) => state.leaveRequest);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(fetchLeaveRequests());
  }, []);
  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>Date</th>
          <th>Month</th>
          <th>Year</th>
          <th>Employee ID</th>
          <th>Leave Type</th>
          <th>Credit</th>
          <th>Debit</th>
          <th>Leave Request</th>
          {/* <th>Leave RequestId</th> */}
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {list.map((item) => {
          const matchedLeave = leaveRequests.find(
            (leave) => leave.id === item.leaveRequestId,
          );
          return (
            <tr key={item.id}>
              <td>{LocalFormatDate(item.createTimestamp?.split(" ")[0])}</td>
              <td>{item.month}</td>
              <td>{item.year}</td>
              <td>{item.employeeId}</td>
              <td className="text-uppercase">{item.leaveType}</td>
              <td>{item.credit}</td>
              <td>{item.debit}</td>
              <td>{matchedLeave?.reason}</td>
              {/* <td>{item.leaveRequestId}</td> */}
              <td>
                {item.debit > 0 ? (
                  <Button
                    variant="success"
                    // onClick={() => onEdit(item)}
                    disabled
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                    title="Cannot be edit because debit have value"
                    className="mr-2 disabled-gray"
                  >
                    <Edit />
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    onClick={() => onEdit(item)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                    className="mr-2"
                  >
                    <Edit />
                  </Button>
                )}

                <Button
                  variant="danger"
                  onClick={() => onDelete(item.id)}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <Trash />
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
export default LeaveTransactionList;
